<template>
  <el-container>
      <el-main>
        <el-col :span="24">
            <Shipfig2 :species="species" :tissue="tissue" />
        </el-col>
        <el-col :span="24">
            <Shiplist2 :species="species" :tissue="tissue" />
        </el-col>
      </el-main>
    </el-container>
</template>

<script>
import Shipfig2 from './Shipfig2.vue';
import Shiplist2 from './Shiplist2.vue';

export default {
  components: { 
      Shipfig2,
      Shiplist2,
  },
  props: {
    species: {
      type: String,
      required: true
    },
    tissue: {
      type: String,
      required: true
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/relationship2/Shippanel2.vue